import { render, staticRenderFns } from "./add-patient.vue?vue&type=template&id=7a350ec4&scoped=true&"
import script from "./add-patient.vue?vue&type=script&lang=js&"
export * from "./add-patient.vue?vue&type=script&lang=js&"
import style0 from "./add-patient.vue?vue&type=style&index=0&id=7a350ec4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a350ec4",
  null
  
)

export default component.exports